
import React from 'react';
import { BusinessOnboarding } from '@/components/BusinessOnboarding';

const OnboardingPage = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <BusinessOnboarding />
    </div>
  );
};

export default OnboardingPage;
